const options = {
  5: "bg-slate-600/5",
  10: "bg-slate-600/10",
  25: "bg-slate-600/25",
  50: "bg-slate-600/50",
  75: "bg-slate-600/75",
  90: "bg-slate-600/90",
  100: "bg-slate-600",
};

const from = {
  5: "from-slate-600/5",
  10: "from-slate-600/10",
  25: "from-slate-600/25",
  50: "from-slate-600/50",
  75: "from-slate-600/75",
  90: "from-slate-600/90",
  100: "from-slate-600",
};

export default function getBackgroundSlate600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
